import React, { useState } from "react";
import { API } from "../../../const";

export default function AllreadyConfirmed() {

    const handleClick = (e) => {
        e.preventDefault();
        window.location.replace(`${API}api/auth/oauth/authorize?response_type=token&client_id=kiuono-creche&redirect_uri=${API}creche/index.html&scope=read`)
    };
    return (
        <main className="main-wrapper login-page">
            <div className="container-login">
                <form className="box-login">
                    <h5 class="mb-4">Votre compte a déja été activé</h5>
                    <button type="button" class="btn-gradient mt-4" onClick={handleClick}>
                        Connexion
          </button>{" "}
                </form>
            </div>
        </main>
    );
}










